import { render, staticRenderFns } from "./CurrentUserPropDialog.vue?vue&type=template&id=1918e1da"
import script from "./CurrentUserPropDialog.vue?vue&type=script&lang=js"
export * from "./CurrentUserPropDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports